/**
 * Canonical training library section names.
 *
 * These strings are stored in `training_plans.section` and
 * `training_programmes.section`, and used as the tab filter on the
 * pt-dashboard. Always use these constants — a casing mismatch between the
 * create-form and the tab filter makes drills silently disappear.
 */
export const TRAINING_SECTIONS = {
  TRAINING: "Training Plan",
  MENTAL: "Mental Training",
  NUTRITION: "Nutrition",
  RECOVERY: "Recovery",
};

export const TRAINING_SECTION_LIST = Object.values(TRAINING_SECTIONS);
